import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class AttachingCertificateValidator {

    attribute_id = [
        Validators.required
    ];

    file_id = [
        Validators.required
    ];

    valid_from = [
        Validators.required
    ];

    valid_to = [
        Validators.required
    ];

    // Error messages
    errorMessages = {
        attribute_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        file_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        valid_from: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        valid_to: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
    }
}